module.exports = __webpack_public_path__ + "img/banner2.69f8aa6a.png";